<template>
  <AbsPopup id="addrSearch" title="주소검색" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="body">
        <div class="search">
          <UInput type="text" placeholder="" v-model="search">
          </UInput>
        </div>
        <li v-if="isLoading" class="loading">
          <div class="dot">
            <div></div><div></div><div></div><div></div><div></div>
          </div>
        </li>
        <li v-else v-for="(item, idx) in list" :key="idx" class="fileItem">
          <span>{{ item.name }}</span>
        </li>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
// import {Base64} from '@/components/js/Utils.js'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
  },
  mounted () {
    // this.$emit('loading', false)
  },
  data () {
    return {
      search: '',
      drive: null,
      initfilename: '',
      fileid: '',
      filetype: 'upb',
      fileparent: '',
      initfileparent: '',
      filename: '',
      parents: [],
      list: [],
      isLoading: false
    }
  },
  name: 'AddrSearch',
  watch: {
    search (val) {
      console.log(val)
      this.$http.post('http://www.juso.go.kr/addrlink/addrLinkApiJsonp.do', {
        confmKey: 'devU01TX0FVVEgyMDIwMDUyMTE1NDkwNzEwOTc4NTM=',
        keyword: val,
        resultType: 'json'
      }).then((e) => {
        console.log(e)
      })
    }
  },
  computed: {
  },
  methods: {
    submit () {
    }
  },
  components: {
    AbsPopup,
    UInput
  }
}
</script>

<style scoped>
#addrSearch {
  padding: 10px 0;
  width: 600px;
}
.search {
  display: flex;
  width: 100%;
  height: 40px;
}
.search .input {
  flex: 1;
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  line-height: 35px;
  padding: 0px;
  margin: 0px;
  min-height: 210px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
}
.body .path {
  display: flex;
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  color: var(--text-title);
}
.body .fileItem {
  display: flex;
  list-style: none;
  text-align: left;
  border-color: var(--line-base);
  padding-left: 20px;
  align-items: center;
  cursor: pointer;
}
.body .fileItem span:first-child {
  margin-right: 5px;
}
.body .fileItem:hover {
  color: var(--bg-white);
  background-color: var(--icon-over);
}
.body li:nth-last-child(2) {
  margin-bottom: 10px;
}
.input > span {
  width: 130px;
  text-align: right;
  padding-right: 10px;
  margin-right: 10px;
  background-color: var(--disable);
}
.loading {
  list-style: none;
  padding: 25px 0;
}
.loading > div {
    position: relative;
    width: 96px;
    height: 96px;
    margin: 0 auto;
    padding: 10px;
}

.dot div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: translateY(-30px);
}

.dot div:nth-child(1) {
    width: 12px;
    height: 12px;
    border-radius: 10px;
    background-color: var(--text-base);
    animation: dot 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(2) {
    width: 10px;
    height: 10px;
    border-radius: 8px;
    background-color: var(--text-base);
    animation: dot 2s 0.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(3) {
    width: 8px;
    height: 8px;
    border-radius: 6px;
    background-color: var(--text-base);
    animation: dot 2s 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(4) {
    width: 6px;
    height: 6px;
    border-radius: 4px;
    background-color: var(--text-base);
    animation: dot 2s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(5) {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background-color: var(--text-base);
    animation: dot 2s 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

@keyframes dot {
    0% {
        transform: rotate(0deg) translateY(-30px);
    }
    100% {
        transform: rotate(360deg) translateY(-30px);
    }
}

.circle div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 76px;
    height: 76px;
    margin: auto;
    border: 10px solid #000;
    border-radius: 48px;
}

.circle div:before {
    position: absolute;
    right: -12px;
    top: -12px;
    width: 50px;
    height: 100px;
    background-color: #FFF;
    content: '';
    transform-origin: 0 50%;
    animation: circle 2s infinite;
}

.circle div:after {
    position: absolute;
    right: -12px;
    top: -12px;
    width: 50px;
    height: 100px;
    background-color: #FFF;
    content: '';
    transform-origin: 0 50%;
    animation: circle 2s 0.45s infinite;
}

@keyframes circle {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/popup/AddrSearch.vue